// Bold accountability message shown ONLY inside the authenticated Weekly
// Check-In experience (first-time setup + every week at check-in). Never on
// the unauthenticated sign-in page.
export default function AccountabilityMessage({ preferredName }) {
  const name = preferredName || "there";
  return (
    <section className="surface-card mt-10 p-8 border-l-4 border-l-brand-primary" data-testid="weekly-accountability-message">
      <div className="font-bold text-brand-ink text-base md:text-lg leading-relaxed space-y-4">
        <p className="font-serif text-2xl md:text-3xl" data-testid="weekly-accountability-heading">
          Welcome to Your Weekly Check In {name} <span aria-hidden>💛</span>
        </p>
        <p>Did you know that:</p>
        <p>Women who self-monitored their progress achieved up to 3 times greater weight loss than those who didn&apos;t.</p>
        <p>Research shows that weekly accountability and progress updates had a 76% success rate far above those who didn&apos;t.</p>
        <p>So what does this mean for you?</p>
        <p>Checking in weekly even when you&apos;ve had a crap week or a bad day is still incredibly valuable and supportive for you.</p>
      </div>
    </section>
  );
}
